<cap-checkbox [formControl]="formControl"
            [formlyAttributes]="field"
            [tabIndex]="to.tabindex || null"
            [style]="to.style || null"
            [styleClass]="to.styleClass || null"
            (onChange)="to.onChange ? to.onChange($event) : null"
            binary="true">
</cap-checkbox>
